import React from 'react';
import { Container, Layout } from '@fiverr-private/layout_components';
import { Link, Typography } from '@fiverr-private/typography';

export const Footer = () => (
  <Container backgroundColor="grey_100" minHeight="400px">
    <Layout
      maxWidth="750px"
      marginY="0"
      marginX="auto"
      paddingTop="12"
      paddingBottom="12"
      paddingX="5"
      boxSizing="unset"
    >
      <Typography as="p" size="b_lg" color="grey_900" marginBottom="4" lineHeight="b_xxl">
        Fiverr’s mission is to transform the way the world creates and works together. We’re shaping the future of work
        with the world’s leading open platform, seamlessly connecting top talent and cutting-edge technology with
        businesses around the globe. From expert freelancers in over 750 skilled categories to best-in-class GenAI
        models and agents, Fiverr provides the most advanced and comprehensive talent and tools for digital
        services—helping businesses get mission-critical projects done fast and cost-effectively.
      </Typography>
      <Typography as="p" size="b_lg" color="grey_900" marginBottom="4" lineHeight="b_xxl">
        From small businesses to Fortune 500 companies, millions trust Fiverr for projects in software and AI
        development, digital marketing, finance, business consulting, video animation, music, architecture, and more.
      </Typography>
      <Typography as="p" size="b_lg" color="grey_900" lineHeight="b_xxl">
        Learn how to future-proof your business with exceptional talent and cutting-edge tools at{' '}
        <Link href="https://fiverr.com" decoration={{ default: 'none', hover: 'underline' }} color="green_700">
          fiverr.com
        </Link>
        . Follow us on{' '}
        <Link
          href="https://www.linkedin.com/company/fiverr-com/posts/?feedView=all"
          decoration={{ default: 'none', hover: 'underline' }}
          color="green_700"
        >
          LinkedIn
        </Link>
        ,{' '}
        <Link
          href="https://www.instagram.com/fiverr/?hl=en"
          decoration={{ default: 'none', hover: 'underline' }}
          color="green_700"
        >
          Instagram
        </Link>
        ,{' '}
        <Link
          href="https://www.tiktok.com/@fiverr"
          decoration={{ default: 'none', hover: 'underline' }}
          color="green_700"
        >
          TikTok
        </Link>
        , and{' '}
        <Link
          href="https://www.facebook.com/Fiverr/"
          decoration={{ default: 'none', hover: 'underline' }}
          color="green_700"
        >
          Facebook
        </Link>
        .
      </Typography>
    </Layout>
  </Container>
);
